module.exports = __webpack_public_path__ + "img/photo-courier.c206e492.jpg";